import React, { FC, useState } from 'react';
import styled, { css } from 'styled-components';

import { append } from '../../utils';

import { IconDeprecated } from '../deprecated/IconDeprecated';
import { SectionContent } from './SectionContent';
import { CosmosComponent } from '../../types';
import { colors, borderColor } from '../../theme/themes';

interface SectionProps extends CosmosComponent {
  title?: string | JSX.Element;
  headerRightElement?: string | JSX.Element;
  isCollapsible?: boolean;
  isDefaultCollapsed?: boolean;
  loading?: boolean;
  contentClassName?: string;
  removePadding?: boolean;
}

export const Section: FC<SectionProps> = ({
  className,
  isCollapsible,
  isDefaultCollapsed,
  title,
  headerRightElement,
  ...contentProps
}) => {
  const [isContentHidden, setHideContent] = useState(
    isCollapsible && isDefaultCollapsed,
  );
  const { testId } = contentProps;

  const toggleHideContent = () => {
    if (isCollapsible) {
      setHideContent(!isContentHidden);
    }
  };

  return (
    <StyledSection className={className} data-test-id={testId}>
      {(title || headerRightElement) && (
        <StyledHeader
          isCollapsible={isCollapsible}
          onClick={toggleHideContent}
          data-test-id={append(testId, 'header')}
        >
          {title && (
            <StyledTitle data-test-id={append(testId, 'title')}>
              {title}
            </StyledTitle>
          )}
          {headerRightElement && (
            <span data-test-id={append(testId, 'right')}>
              {headerRightElement}
            </span>
          )}
          {isCollapsible && (
            <StyledIcon
              name="chevron"
              isContentHidden={isContentHidden}
              testId={append(testId, 'expandable')}
            />
          )}
        </StyledHeader>
      )}
      <SectionContent isContentHidden={isContentHidden} {...contentProps} />
    </StyledSection>
  );
};

export const StyledSection = styled.div`
  margin: 20px 0;
  padding: 0;
  font-family: 'Open Sans', sans-serif;
  background: ${colors.white};
  border: solid 0.5px ${borderColor.primaryBorder};
`;

const StyledHeader = styled.div<{ isCollapsible?: boolean }>`
  padding: 10px 28px;
  min-height: 33px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 2px solid ${colors.r2d2Blue};

  ${({ isCollapsible }) =>
    isCollapsible &&
    css`
      cursor: pointer;
    `}
`;

const StyledTitle = styled.span`
  font-weight: 300;
  color: #202432;
  letter-spacing: normal;
  font-size: 20px;
`;

//If hidden, the chevron should point down (not rotated)
export const StyledIcon = styled(IconDeprecated)<{ isContentHidden?: boolean }>`
  width: 26px;
  transform: rotate(270deg);
  transition: transform 0.25s ease-in-out;

  ${({ isContentHidden }) =>
    isContentHidden &&
    css`
      transform: rotate(0deg);
    `}
`;
